class Controller {
  constructor($mdBottomSheet) {
    "ngInject";

    this.$mdBottomSheet = $mdBottomSheet;
  }

  close() {
    this.$mdBottomSheet.cancel();
  }

  confirm() {
    const title = this.title;
    const comment = this.comment;

    this.$mdBottomSheet.hide({ title, comment });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/mainFooter/reportBottomSheet/reportBottomSheet.controller.js